import { Box, Typography } from "@mui/material";
import { blackColor, lightBlackColor, whiteColor } from "../constants/colors";

const SmallTextInput = ({
  label,
  value,
  onChange,
  inputStyle,
  labelStyle,
  containerStyle,
  additionalLabel,
  disabled
}) => {
  return (
    <Box sx={{ display: "flex", alignItems: "flex-end", ...containerStyle }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <Typography
          sx={{
            textAlign: "center",
            fontSize: "12px",
            lineHeight: "12px",
            color: blackColor,
            fontWeight: "500",
            ...labelStyle,
          }}
        >
          {label}
        </Typography>
        <input
        disabled={disabled}
          style={{
            all: "unset",
            borderColor: blackColor,
            borderWidth: "1px",
            paddingTop: "1px",
            paddingBottom: "1px",
            backgroundColor: whiteColor,
            borderStyle: "solid",
            color: blackColor,
            fontSize: "20px",
            fontWeight: "500",
            borderRadius: "0px",
            paddingLeft: "2px",
            paddingRight: "2px",
            width: "33px",
            height: "23px",
            textAlign: "center",
            ...inputStyle,
          }}
          value={value}
          onChange={(event) => onChange(event.target.value)}
        />
      </Box>
      <Typography
        sx={{
          fontWeight: "500",
          fontSize: "20px",
          color: lightBlackColor,
          marginLeft: "3px",
        }}
      >
        {additionalLabel}
      </Typography>
    </Box>
  );
};

export default SmallTextInput;
